import React, { useState } from "react";
import styled from "@emotion/styled";
import Tooltip from '@mui/material/Tooltip';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTheme } from "@mui/styles";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { Button, FlexWrapper, Typography } from "../../../../../StyledComponents";

const TagTypeDisplay = ({ tagData, assignmentType, tagType }) => {
  const theme = useTheme()

  const [tagShown, setTagShown] = useState(null)
  const [fieldsShown, setFieldsShown] = useState([])
  const [showingFields, setShowingFields] = useState(false)

  const showFields = (fields, tag) => {
    setTagShown(tag)
    setFieldsShown(fields)
    setShowingFields(true)
  }
  const hideFields = () => {
    setTagShown(null)
    setFieldsShown([])
    setShowingFields(false)
  }

  return (
    <TagDisplay>
      <TagGroup>
              {tagData && tagData.tags.map((tag) => (((tag.apiMapping === 'propertyType' || tag.apiMapping === 'loanType' || tag.apiMapping === 'taxInitialDelinquencyYear')) &&
                <TagCluster key={tag._id || tag.label}>
                  <Tooltip
                    componentsProps={{tooltip: {sx: {
                      color: `${theme.tooltip.label.color}`,
                      backgroundColor: `${theme.tooltip.label.background}`,
                      border: `0.1rem solid ${theme.tooltip.label.border}`,
                      borderBottom: `0.1rem solid ${theme.tooltip.label.border}`,
                      opacity: '0',
                      borderRadius: '1rem',
                      width: 'fit-content',
                      minWidth: 'fit-content',
                      padding: '0.5rem 1rem',
                    }}}}
                    PopperProps={{modifiers: [{
                      name: "offset",
                      options: {
                        offset: [0, 0],
                      },
                    }]}}
                    title={!showingFields && tagType !== 'mortgage' ?
                      <FlexWrapper className="column">
                        <Typography className="bold alignTextCenter">
                          View violated fields
                        </Typography>
                      </FlexWrapper>
                    : null} 
                    placement="top"
                    arrow
                  >
                    <TagChip
                      type="button"
                      className={tagType === 'mortgage' ?
                        "onDisplay noHover"
                      : (tagShown === `${tag.label}` || tagShown === null) ? 
                        "onDisplay" 
                      : 
                        "onDisplay hidden"
                      }
                      onClick={tagType === 'mortgage' ? null : () => showFields(tag.discrepancyFields, tag.label)}
                    >
                      <LocalOfferIcon />
                      <span>{tag.label}</span>
                    </TagChip>
                  </Tooltip>
                  {(tagType === 'mortgage' && (tag.label === 'Loan Type' || tag.label === 'Property Type' || tag.apiMapping === 'taxInitialDelinquencyYear')) &&
                    <TagFields className={(tagShown === `${tag.label}` || tagShown === null) ? "onDisplay" : "hidden"}>
                      {tag.discrepancyFields.map((field, index) => (
                        index === (tag.discrepancyFields.length - 1) ?
                          <span key={field}>
                            {field}
                          </span>
                        :
                          <span key={field}>
                            {field},
                          </span>
                      ))}
                    </TagFields>
                  }
                </TagCluster>
              ))}
      </TagGroup>
      <TagGroup>
              {tagData && tagData.tags.map((tag) => (((tag.apiMapping !== 'propertyType' && tag.apiMapping !== 'loanType' && tag.apiMapping !== 'taxInitialDelinquencyYear')) &&
                <TagCluster key={tag._id || tag.label}>
                  <Tooltip
                    componentsProps={{tooltip: {sx: {
                      color: `${theme.tooltip.label.color}`,
                      backgroundColor: `${theme.tooltip.label.background}`,
                      border: `0.1rem solid ${theme.tooltip.label.border}`,
                      borderBottom: `0.1rem solid ${theme.tooltip.label.border}`,
                      opacity: '0',
                      borderRadius: '1rem',
                      width: 'fit-content',
                      minWidth: 'fit-content',
                      padding: '0.5rem 1rem',
                    }}}}
                    PopperProps={{modifiers: [{
                      name: "offset",
                      options: {
                        offset: [0, 0],
                      },
                    }]}}
                    title={!showingFields && tagType !== 'mortgage' ?
                      <FlexWrapper className="column">
                        <Typography className="bold alignTextCenter">
                          View violated fields
                        </Typography>
                      </FlexWrapper>
                    : null} 
                    placement="top"
                    arrow
                  >
                    <TagChip
                      type="button"
                      className={tagType === 'mortgage' ?
                        "onDisplay noHover"
                      : (tagShown === `${tag.label}` || tagShown === null) ? 
                        "onDisplay" 
                      : 
                        "onDisplay hidden"
                      }
                      onClick={tagType === 'mortgage' ? null : () => showFields(tag.discrepancyFields, tag.label)}
                    >
                      <LocalOfferIcon />
                      <span>{tag.label}</span>
                    </TagChip>
                  </Tooltip>
                  {(tagType === 'mortgage' && (tag.label === 'Loan Type' || tag.label === 'Property Type')) &&
                    <TagFields className={(tagShown === `${tag.label}` || tagShown === null) ? "onDisplay" : "hidden"}>
                      {tag.discrepancyFields.map((field, index) => (
                        index === (tag.discrepancyFields.length - 1) ?
                          `${field}`
                        :
                          `${field},`
                      ))}
                    </TagFields>
                  }
                </TagCluster>
              ))}
      </TagGroup>
            <FieldPanel className={(showingFields? 'heightOnDisplay' : 'heightHidden')}>
              <FieldPanelInner className={tagShown ? "onDisplay" : "hidden"}>
                <Tooltip
                  componentsProps={{tooltip: {sx: {
                    color: `${theme.tooltip.label.color}`,
                    backgroundColor: `${theme.tooltip.label.background}`,
                    border: `0.1rem solid ${theme.tooltip.label.border}`,
                    borderBottom: `0.1rem solid ${theme.tooltip.label.border}`,
                    opacity: '0',
                    borderRadius: '1rem',
                    width: 'fit-content',
                    minWidth: 'fit-content',
                    padding: '0.5rem 1rem',
                  }}}}
                  PopperProps={{modifiers: [{
                    name: "offset",
                    options: {
                      offset: [0, -6],
                    },
                  }]}}
                  title={tagShown ?
                    <FlexWrapper className="column">
                      <Typography className="bold alignTextCenter">
                        Close
                      </Typography>
                    </FlexWrapper>
                  :null} 
                  placement="top"
                  arrow
                >
                  <Button onClick={() => hideFields()} className="round secondaryLight">
                    <CancelIcon />
                  </Button>
                </Tooltip>
                <FieldCopy className={tagShown ? "onDisplay" : "hidden"}>
                  <Typography className="bold">
                    {assignmentType === 'query' ?
                      `Fields found in violation that resulted in this tag being applied:`
                    :
                      `Fields that apply this tag when a violation is found:`
                    }
                  </Typography>
                  {fieldsShown.map((field, index) => (
                    index === (fieldsShown.length - 1) ?
                      <FieldValue key={field}>
                        {field}
                      </FieldValue>
                    :
                      <FieldValue key={field}>
                        {field},
                      </FieldValue>
                  ))}
                </FieldCopy>
              </FieldPanelInner>
            </FieldPanel>
    </TagDisplay>
  )
}

const TagDisplay = styled.div`
  min-width: 0;
  display: grid;
  gap: 0.75rem;
`

const TagGroup = styled.div`
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
`

const TagCluster = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
`

const TagChip = styled.button(({ theme }) => `
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 2.3rem;
  padding: 0.4rem 0.75rem;
  border: 0.1rem solid ${theme.palette.primary.dark};
  border-radius: 999rem;
  background: ${theme.palette.primary.labelTransparent};
  color: ${theme.palette.primary.dark};
  font-size: 0.9rem;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;

  svg {
    width: 1rem;
    height: 1rem;
  }

  :hover {
    background: ${theme.palette.common.white};
    border-color: ${theme.palette.primary.main};
  }

  &.noHover {
    cursor: default;

    :hover {
      background: ${theme.palette.primary.labelTransparent};
      border-color: ${theme.palette.primary.dark};
    }
  }

  &.hidden {
    display: none;
  }
`)

const TagFields = styled.div(({ theme }) => `
  color: ${theme.palette.common.grayText};
  font-size: 0.9rem;
  font-weight: 700;

  &.hidden {
    display: none;
  }
`)

const FieldPanel = styled.div(({ theme }) => `
  min-height: 0;
  border-top: 0.1rem solid ${theme.palette.common.grayBorder};

  &.heightHidden {
    display: none;
  }

  &.heightOnDisplay {
    display: block;
    padding-top: 0.75rem;
  }
`)

const FieldPanelInner = styled.div(({ theme }) => `
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem;
  border-radius: 0.8rem;
  background: ${theme.palette.common.cardBackground};

  &.hidden {
    display: none;
  }
`)

const FieldCopy = styled(FlexWrapper)`
  min-width: 0;
  flex-wrap: wrap;
  gap: 0.25rem;
  padding: 0;

  &.hidden {
    display: none;
  }
`

const FieldValue = styled.span(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 1rem;
  font-weight: 400;
  margin-left: 0.35rem;
`)

export default TagTypeDisplay
